import { InsuranceFlood } from '../icons'

export const ExtraInsuranceSmeItemIconsEnum = {
  Flood: 'flood',
} as const

export type ExtraInsuranceSmeItemIconsEnum = typeof ExtraInsuranceSmeItemIconsEnum[keyof typeof ExtraInsuranceSmeItemIconsEnum]

export const getExtraInsuranceSmeIcon = (
  icon: ExtraInsuranceSmeItemIconsEnum,
  size: string = '48px',
  color: string = 'gray.800',
) => {
  switch (icon) {
    case 'flood':
      return <InsuranceFlood width={size} height={size} color={color} />
  }
}
